class UrlFormatter {
    constructor(url) {
        this.url = url;
        this.isEmail = this.looksLikeEmail(url);
        this.isUrl = !this.looksLikeDate(url);
    }

    format = () => {
        if (this.isEmail) {
            return this.surroundWithAnchor(this.url, 'mailto:');
        }
        if (this.isUrl) {
            return this.surroundWithAnchor(this.url, 'http://');
        }
        return this.url;
    };

    convertToAbsoluteUrl = (url, protocol) => {
        if (!this.startsWithProtocol(url)) {
            return `${protocol}${this.url}`;
        }
        return url;
    };

    surroundWithAnchor = (url, protocol) => `<a target="_blank" href="${this.convertToAbsoluteUrl(url, protocol)}">${url}</a>`;

    startsWithProtocol = (url) => {
        const protocols = ['http', 'https', 'ftp', 'mailto', 'file', 'tel'];
        return protocols.some((protocol) => url.extensions.startsWith(protocol));
    };

    looksLikeDate = (url) => url.extensions.containsOnlyDigitsAndDots();

    looksLikeEmail = (url) => url.indexOf('@') !== -1;
}
export default UrlFormatter;